import { render } from "./SciPage.vue?vue&type=template&id=09e13e00"
import script from "./SciPage.vue?vue&type=script&lang=js"
export * from "./SciPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__